import React, { useState } from "react";
import axios from "axios";
import DisputesHeaderLight from "../Components/DisputesHeaderLight";
import { Container } from "react-bootstrap";
import * as Yup from "yup";
import { Input } from "../Components/Form/Form";
import Buttons from "../Components/Button/Buttons";

import { resetForm } from "../Functions/Utilities";
import { Formik, Form } from "formik";


const ForgotPassword = () => {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleSubmit = async (values) => {

    try {
      const response = await axios.post(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}password-reset-request/`,
        values
      );

      if (response.status === 200){
        setSuccess(`${response.data["success"] ? response.data["success"] : response.data['error'] ? response.data['error'] : 'If the email you specified exists in our system, we have sent a password reset link to it.'}`);
      }

    } catch (error) {

      if (error.response && error.response.data['error']) {

          setError(error.response.data['error']);

      }
    }

  }

  return (
    <>
    <DisputesHeaderLight/>
    <section className="py-[160px] overflow-hidden cover-background lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px]">
        <Container>

            <div>
              <div className="text-[80px] mb-2 leading-[95px] text-[#ef8d23] font-bold uppercase tracking-[-7px] xl:tracking-[-4px] lg:text-[90px] md:text-[70px] md:leading-[65px] sm:text-[45px] sm:leading-[43px]">
                Forgot Password
              </div>

              <div className="bg-lightgray p-16 lg:mt-[35px] md:p-10">
                <Formik
                  initialValues={{ email: ""}}
                  validationSchema={Yup.object().shape({
                    email: Yup.string()
                      .email("Invalid email.")
                      .required("Field is required."),

                  })}
                  onSubmit={async (values, actions) => {
                    await new Promise((r) => handleSubmit(values));
                    resetForm(actions);
                  }}
                >
                  {({ isSubmitting, status }) => (
                    <Form>
                      {error && (
                        <div
                          className="mb-3 p-3 rounded text-danger"
                          style={{ border: "2px solid red" }}
                        >
                          {error}
                        </div>
                      )}
                      {success && (
                        <div
                          className="mb-3 p-3 rounded text-[#ef8d23]"
                          style={{ border: "2px solid #ef8d23" }}
                        >
                          {success}
                        </div>
                      )}
                      <Input

                        showErrorMsg={false}
                        name="email"
                        type="email"
                        labelClass="mb-[20px]"
                        label={
                          <div className="mb-[15px]">
                            Email address{" "}
                            <span className="text-[#fb4f58]">*</span>
                          </div>
                        }
                        className="py-[13px] px-[15px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                        placeholder="Enter your email"
                        data-test="email-input"
                      />


                      <Buttons
                        ariaLabel="send reset email"
                        type="submit"
                        className="btn-fill btn-fancy w-full font-medium font-serif rounded-none uppercase"
                        themeColor="#232323"
                        color="#fff"
                        size="md"
                        title="Send reset email"
                      />
                    </Form>
                  )}
                </Formik>
              </div>
            </div>

        </Container>
      </section>
    </>
  )

}

export default ForgotPassword;
